import { render } from "./edit-pendamping-modal.vue?vue&type=template&id=6d3b7280&scoped=true"
import script from "./edit-pendamping-modal.vue?vue&type=script&lang=js"
export * from "./edit-pendamping-modal.vue?vue&type=script&lang=js"

import "./edit-pendamping-modal.vue?vue&type=style&index=0&id=6d3b7280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3b7280"]])

export default __exports__